import {
	useBlockProps,
	useInnerBlocksProps,
	MediaUpload,
	MediaUploadCheck,
} from '@wordpress/block-editor';
import { Button, Placeholder, PanelBody } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

import InsertImageFromUrl from '../_shared/insert-image-from-url';
import { PANEL_INNER_TEMPLATE } from '../AccordionImages/constants';
import { getPanelPaddingVars } from './panel-padding';

export default function Edit( { attributes, setAttributes } ) {
	const { imageId, imageUrl, imageAlt } = attributes;

	const paddingVars = getPanelPaddingVars( attributes );

	const blockProps = useBlockProps( {
		className: 'brandy-accordion-panel',
		style: Object.keys( paddingVars ).length ? paddingVars : undefined,
	} );

	const innerBlocksProps = useInnerBlocksProps(
		{ className: 'brandy-accordion-panel__overlay' },
		{ template: PANEL_INNER_TEMPLATE }
	);

	const onSelectImage = ( media ) => {
		setAttributes( {
			imageId: media.id,
			imageUrl: media.url,
			imageAlt: media.alt || '',
		} );
	};

	const onRemoveImage = () => {
		setAttributes( {
			imageId: 0,
			imageUrl: '',
			imageAlt: '',
		} );
	};

	// Images inserted by link have no attachment row, so the id stays 0.
	// save.jsx writes only imageUrl/imageAlt, so they render like library ones.
	const onSelectImageUrl = ( url ) => {
		setAttributes( {
			imageId: 0,
			imageUrl: url,
			imageAlt: '',
		} );
	};

	return (
		<>
			<InspectorControls>
				<PanelBody
					title={ __( 'Panel Image', 'brandy-blocks' ) }
				>
					<InsertImageFromUrl onSubmit={ onSelectImageUrl } />
				</PanelBody>
			</InspectorControls>
		<div { ...blockProps }>
			{ /* The library picker sits inside MediaUploadCheck; the URL form
			     stays outside it, since inserting by link needs no upload rights. */ }
			{ ! imageUrl ? (
				<Placeholder
					icon="format-image"
					label={ __( 'Accordion Panel', 'brandy-blocks' ) }
					instructions={ __(
						'Select an image for this panel, or insert one from a URL',
						'brandy-blocks'
					) }
				>
					<MediaUploadCheck>
						<MediaUpload
							onSelect={ onSelectImage }
							allowedTypes={ [ 'image' ] }
							value={ imageId }
							render={ ( { open } ) => (
								<Button
									variant="primary"
									onClick={ open }
								>
									{ __(
										'Select Image',
										'brandy-blocks'
									) }
								</Button>
							) }
						/>
					</MediaUploadCheck>
					<InsertImageFromUrl onSubmit={ onSelectImageUrl } />
				</Placeholder>
			) : (
				<>
					<img src={ imageUrl } alt={ imageAlt } />
					{ /* Hover-revealed overlay: buttons only. Replacing by URL
					     lives in the inspector, which has room for a form and
					     does not disappear when the pointer leaves. */ }
					<MediaUploadCheck>
						<MediaUpload
							onSelect={ onSelectImage }
							allowedTypes={ [ 'image' ] }
							value={ imageId }
							render={ ( { open } ) => (
								<div className="brandy-accordion-panel__controls">
									<Button
										variant="primary"
										onClick={ open }
									>
										{ __(
											'Replace',
											'brandy-blocks'
										) }
									</Button>
									<Button
										variant="link"
										isDestructive
										onClick={ onRemoveImage }
									>
										{ __(
											'Remove',
											'brandy-blocks'
										) }
									</Button>
								</div>
							) }
						/>
					</MediaUploadCheck>
				</>
			) }
			<div { ...innerBlocksProps } />
		</div>
		</>
	);
}
